

































































































import {Component, Vue} from 'vue-property-decorator';
import moment from 'moment';
import {progress} from '@/script/progress';
import api from '@/infrastructure/api/api';
import download from '@/infrastructure/api/download';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import ButtonPanel from '@/components/menu/panel/ButtonPanel.vue';
import IconButton from '@/components/atom/button/IconButton.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import {渓仁会納品データ型, 渓仁会納品データ検索依頼型, 渓仁会納品データ検索結果型} from '@/type/custom/keijinkai/deliverydata';
import 渓仁会納品データ検索条件チェッカー from '@/type/custom/keijinkai/渓仁会納品データ検索条件チェッカー';

@Component({
  components: {
    Datepicker,
    ButtonPanel,
    IconButton,
    ConfirmDialog,
    AlertDialog,
    NormalButton,
    WholesaleSelector,
  },
})
export default class DeliveryDataOutput extends Vue {
  // data
  検索条件: 渓仁会納品データ検索依頼型 = {...this.デフォルトの検索条件};
  検索結果: 渓仁会納品データ型[] = [];

  選択行番号: number | null = null;
  アラートメッセージ: string[] | string | null = null;

  // computed
  get 表示件数(): number {
    return this.検索結果.length;
  }

  get デフォルトの検索条件(): 渓仁会納品データ検索依頼型 {
    return {
      納品日FROM: moment().toDate(),
      納品日TO: null,
      卸コード: null,
      出力対象区分: '再出力しない',
    };
  }

  get ファイル出力できる(): boolean {
    return this.検索結果.length > 0;
  }

  // method
  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  async クリアする(): Promise<void> {
    this.検索条件 = {...this.デフォルトの検索条件};
    this.検索結果 = [];
    this.選択行番号 = null;
    this.アラートメッセージ = null;
    this.closeDialog('クリアダイアログ');
  }

  検索条件入力エラー判定(項目名: string): boolean {
    const checker = new 渓仁会納品データ検索条件チェッカー(this.検索条件);
    return checker.hasError(項目名);
  }

  行が選択されている(行番号: number): boolean {
    if (this.選択行番号 === null) {
      return false;
    }
    return this.選択行番号 === 行番号;
  }

  行を選択する(行番号: number): void {
    this.選択行番号 = 行番号;
  }

  async 検索する(): Promise<void> {
    const checker = new 渓仁会納品データ検索条件チェッカー(this.検索条件);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    await progress(this.渓仁会納品データを検索する);
  }

  async 渓仁会納品データを検索する(): Promise<void> {
    await api.渓仁会納品データを検索する(this.検索条件)
      .then((response: 渓仁会納品データ検索結果型) => {
        this.検索結果 = response.渓仁会納品データ検索結果一覧;
        if (this.検索結果.length === 0) {
          this.showAlert('該当の納品データは存在しません');
          return;
        }
        if (response.アラートメッセージ) {
          this.showAlert(response.アラートメッセージ);
        }
      }).catch((error: any) => {
        if (error.data.errors) {
          this.showAlert(error.data.errors);
        }
        if (error.data.message && !error.data.errors) {
          this.showAlert(error.data.message);
        }
      });
  }

  async 出力する(): Promise<void> {
    await progress(this.渓仁会納品データを出力する);
    this.closeDialog('出力ダイアログ');
  }

  async 渓仁会納品データを出力する(): Promise<void> {
    await download.渓仁会納品データを出力する('PROGOS_NONYU_EXPORT.txt', this.検索条件);
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.$modal.show('納品データ出力アラート');
  }

  // lifecycle hook
  // do nothing
}
